import React, { useEffect, useMemo, useState } from 'react';
import { get, reverse, sortBy } from 'lodash';
import Coupon from '../../components/coupon/Coupon';
import { useCouponStoreContext } from '../../contexts/coupon';
import { COUPON_FILTER_TYPE } from '../../const';

export default () => {
  const {
    coupons,
    couponsDict,
    customerCouponFrontItems,
    voucherShopItems,
    getCoupons,
    isInited,
    isLoading,
    setPriorityCoupon,
  } = useCouponStoreContext();
  const [filterType, setFilterType] = useState(COUPON_FILTER_TYPE.VALID);
  const [isDialoglOpen, setIsDialogOpen] = useState(false);
  const [priorityCouponIdToSet, setPriorityCouponIdToSet] = useState('');
  const dialogData = get(couponsDict, [priorityCouponIdToSet], undefined);

  useEffect(() => {
    (async () => {
      await getCoupons();
    })();
  }, [getCoupons]);

  const data = useMemo(() => {
    const list = coupons.filter((coupon) => {
      const { isValid, isUsed, isExpired } = coupon;
      if (filterType === COUPON_FILTER_TYPE.VALID) {
        if (isUsed) return false;
        if (isExpired) return false;
        if (isValid) return true;
      } else {
        if (isUsed) return true;
        if (isExpired) return true;
        if (isValid) return false;
      }
      return false;
    });

    if (filterType === COUPON_FILTER_TYPE.INVALID) return reverse(sortBy(list, ['gotTime']));
    return list;
  }, [coupons, filterType]);

  const afterSendButtonClick = () => getCoupons();

  const onFilterButtonCLick = (type) => {
    setFilterType(type);
  };

  const onItmeClick = (couponId) => {
    setIsDialogOpen(true);
    setPriorityCouponIdToSet(couponId);
  };

  const onDialogOkButtonClick = () => {
    setPriorityCoupon(priorityCouponIdToSet);
    setIsDialogOpen(false);
  };

  const onDialogCancelButtonClick = () => {
    setIsDialogOpen(false);
  };

  return (
    <Coupon
      afterSendButtonClick={afterSendButtonClick}
      coupons={data}
      customerCouponFrontItems={customerCouponFrontItems}
      dialogData={dialogData}
      filterType={filterType}
      isDialoglOpen={isDialoglOpen}
      isInited={isInited}
      isLoading={isLoading}
      voucherShopItems={voucherShopItems}
      onDialogCancelButtonClick={onDialogCancelButtonClick}
      onDialogOkButtonClick={onDialogOkButtonClick}
      onFilterButtonCLick={onFilterButtonCLick}
      onItmeClick={filterType === COUPON_FILTER_TYPE.VALID ? onItmeClick : () => {}}
    />
  );
};
